import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { reactive, ref, onMounted, computed } from 'vue';
import { PropType } from 'vue'
import tools from '@/tools'


export default /*#__PURE__*/_defineComponent({
  __name: 'Datetime',
  props: {
  label: {
    type: String,
    default: '日期时间'
  },
  type: {
    type: String,
    default: 'date'
  },
  rules: Array,
  value: [String, Number],
  disabled: {
    type: Boolean,
    default: false
  },
  min: {
    type: Date,
    default: new Date(1950, 0, 1)
  },
  max: {
    type: Date,
    default: new Date(2042, 0, 1)
  }
},
  emits: ['update:value'],
  setup(__props, { emit }) {

const props = __props

onMounted(() => {

})

const Options = ref({
  name: '日期时间选择器'
})





const currentDate = ref(new Date());

const result = ref()
const visible = ref(false)
const onShow = () => {
  if (!props.disabled) {
    visible.value = true
  }
}

const onConfirm = (value: any) => {
  let format = 'YYYY-MM-DD'

  switch (props.type) {
    case 'month-day':
      format = 'MM-DD'
      break;

    default:
      format = 'YYYY-MM-DD'
      break;
  }

  emit('update:value', tools.dayjs(value).format(format))
  visible.value = false
};




return (_ctx: any,_cache: any) => {
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_datetime_picker = _resolveComponent("van-datetime-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_van_field, {
      modelValue: __props.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(value) ? (value).value = $event : null)),
      "is-link": !props.disabled,
      disabled: props.disabled,
      readonly: "",
      label: __props.label,
      placeholder: __props.label,
      rules: __props.rules,
      onClick: onShow
    }, null, 8, ["modelValue", "is-link", "disabled", "label", "placeholder", "rules"]),
    _createVNode(_component_van_popup, {
      show: visible.value,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((visible).value = $event)),
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_datetime_picker, {
          type: __props.type,
          modelValue: currentDate.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((currentDate).value = $event)),
          onConfirm: onConfirm,
          onCancel: _cache[2] || (_cache[2] = ($event: any) => (visible.value = false)),
          "min-date": props.min,
          "max-date": props.max
        }, null, 8, ["type", "modelValue", "min-date", "max-date"])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})